import { computed } from 'vue';
import { useField } from 'vee-validate';

const validDirty = ({ meta, errorMessage }) => {
  if (errorMessage.value) {
    return ['input'];
  }
  if (meta.dirty || meta.touched) {
    return ['blur'];
  }
  return ['change'];
};

const passive = () => [];

const lazy = ({ meta, errorMessage }) => {
  return ['change'];
};

const aggressive = () => ['input'];

const eager = ({ errorMessage }) => {
  if (errorMessage.value) {
    return ['input'];
  }

  return ['change'];
};

export const modes = {
  passive,
  lazy,
  aggressive,
  eager,
  validDirty,
};

export const defineValidationField = (props, onBlur = undefined) => {
  const {
    value: inputValue,
    errorMessage,
    handleChange,
    handleBlur,
    meta,
    errors,
  } = useField(props.name, props.rules, {
    initialValue: props.modelValue.value,
    validateOnValueUpdate: false,
  });

  const handlers = computed(() => {
    const on = {
      blur: onBlur || handleBlur,
      input: [(e) => handleChange(e, false)],
    };
    const triggers = modes[props.mode.value]({
      errorMessage,
      meta,
    });
    triggers.forEach((t) => {
      if (Array.isArray(on[t])) {
        on[t].push(handleChange);
      } else {
        on[t] = handleChange;
      }
    });
    return on;
  });

  return { inputValue, handlers, errors, errorMessage, handleBlur, handleChange };
};
